// extracted by mini-css-extract-plugin
export default {"wrap":"Plan_wrap__rynGt","plan":"Plan_plan__oiBbv","buttons":"Plan_buttons__4wW34","button":"Plan_button__XxpAM"};